export default function(n) {
  return function() {
    for (var sum = 0, i = 0; i < n; ++i) sum += Math.random();
    return sum;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/irwinHall.js
// module id = rwwP
// module chunks = 1